import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect, Switch } from "react-router-dom";

import * as userActions from "../../actions/userActions";
import * as codeActions from "../../actions/codeActions";

import PrivateRoute from "./PrivateRoute";
import PageContainer from "../styled/PageContainer";

import Sidebar from "../common/Sidebar";
import Dashboard from "../dashboard/NewDashboard";
import AccountSettingsPage from "../user-account/AccountSettingsPage";

import {
  CustomerPage,
  CustomerAddPage,
  CustomerEditPage,
  CustomerNotesPage,
  CustomerCallsPage,
  CustomerItgluePage
} from "../customer";

import {
  ContractPage,
  ContractAddPage,
  ContractEditPage,
  ContractProjectsPage,
  ContractNotesPage,
  PurchaseOrderPage
} from "../contract";

import {
  ProjectAddPage,
  ProjectEditPage,
  ProjectCallsPage,
  ProjectTasksPage,
  ProjectNotesPage,
  ProjectAttachmentsPage
} from "../project";

import {
  CallPage,
  CallAddPage,
  CallEditPage,
  CallPartsPage,
  TimesheetPage,
  CallApprovalPage,
  CallNotesPage
} from "../call";

import MaintenancePage from "../alt-customer-names/AlternativeCustomerNamesPage";

import TimePlannerPage from "../call/timeplanner";

import { TimesheetPage as TimesheetPage2 } from "../call/timesheet";

import {
  ExpensePage,
  ExpenseAddPage,
  ExpenseEditPage,
  ExpenseApprovalPage
} from "../expense";

import {
  PtoRequestListPage,
  PtoRequestPage,
  PtoApprovalPage
} from "../ptoRequest";

import CodePage from "../code/CodePage";
import ServicePage from "../service/ServicePage";
import ServiceAddPage from "../service/ServiceAddPage";
import ServiceEditPage from "../service/ServiceEditPage";
import RolePage from "../role/RolePage";
import HolidayPage from "../holiday/HolidayPage";
import ContractTierPage from "../contract-tier/ContractTierPage";
import TaskPage from "../task/TaskPage";
import DepartmentCategoryPage from "../department-category/DepartmentCategoryPage";

import { DepartmentPage } from "../department";
import { UserPage, UserAddPage, UserEditPage } from "../user";
import { SupportTicketPage, ViewSupportTicket } from "../support-ticket";

import ProjectListPage from "../project/ProjectListPage";
import ProjectProgressReviewPage from "../project/ProjectProgressReviewPage";

import { ActivityPage } from "../activity";

// IRIS REPORTS
import ReportsPage from "../reports/ReportsPage";
import TimeSummaryPage from "../reports/TimeSummary";
import TimeTrackerPage from "../reports/TimeTracker";
import ProjectProgressPage from "../reports/ProjectProgress";
import EmployeeSummaryByDepartmentPage from "../reports/EmployeeSummaryByDepartment/ index";
import SalesPerformancePage from "../reports/SalesPerformance";
// import CustomerCollectionPage from "../reports/CustomerCollection";
import ProjectSummaryPage from "../reports/ProjectSummary";
import ContractsByTypePage from "../reports/ContractsByType";
import CustomerAnnualRevenueAnalysisPage from "../reports/CustomerAnnualRevenueAnalysis";
import PrepaidDeferredRevenueBalancePage from "../reports/PrepaidDeferredRevenueBalance";
import RetainerOrClientCareContractsPage from "../reports/RetainerOrClientCareContracts";

import ApprovalRouter from "../approval";
import PtoBalanceReportPage from "../reports/PtoBalance";
import BillableCustomerRates from "../reports/BillableCustomerRates";
import CallDetail from "../reports/CallDetail";
import TaskDetail from "../reports/TaskDetail";
import CustomerProjectStatus from "../reports/CustomerProjectStatus";
import ProjectSummaryByCustomer from "../reports/ProjectSummaryByCustomer";
import MonthlyRevenueAnalysis from "../reports/MonthlyRevenueAnalysis";
import CustomerBalanceSummary from "../reports/CustomerBalanceSummary";
import ITManagedServices from "../reports/ITManageedServices";
import ITHealthScorePage from "../reports/ITManageedServices/ITHealthScore/ITHealthScorePage";
import ResourceSummaryPage from "../reports/ResourceSummary";
import DepartmentProjectSummary from "../reports/DepartmentProjectSummary";
import EmployeeSummaryByProject from "../reports/EmployeeSummaryByProject";
// import InvoiceDetail from "../reports/InvoiceDetail";
import DailyCallCompletion from "../reports/DailyCallCompletion";
import OpenSupportTickets from "../reports/OpenSupportTickets";
import ProjectServiceAnalysis from "../reports/ProjectServiceAnalysis";
import SupportTicketDetailReport from "../reports/SupportTicketDetail";

import BulkCallMigrationPage from "../call/bulk-migration";
import { SessionExpiredModal } from "../auth/SessionExpiredModal";

import ProjectKeywordsPage from "../project-keywords";
import SupportResourcesPage from "../support-resources";

import EmployeeUtilization from "../reports/EmployeeUtilization";

import ActiveContracts from "../reports/ActiveContracts";
import ActiveProjects from "../reports/ActiveProjects";

const ROLES = {
  HR: 1100,
  SALESPERSON: 2000,
  BILLING_ADMIN: 4000,
  MANAGER: 5000,
  CEO: 8000,
  ADMIN: 9000
};

class UserRoute extends Component {
  constructor(props) {
    super(props);
    window.addEventListener("resize", this.handleResize);

    this.state = {
      DEVICE_WIDTH: 768,
      isAuth: false,
      isAdmin: props.auth.isAdmin,
      isDark: props.auth.user.is_night_mode,
      isOpen: !props.isMobile
        ? localStorage.getItem("menuIsOpen") === "true"
        : false
    };
  }

  componentDidMount = () => {
    const { codes, actions } = this.props;
    if (!codes.length) actions.loadCodes();
    if (window.innerWidth !== this.state.DEVICE_WIDTH) {
      this.setState({ DEVICE_WIDTH: window.innerWidth });
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleResize);
  };

  handleResize = () => {
    if (window.innerWidth !== this.state.DEVICE_WIDTH) {
      this.setState({ DEVICE_WIDTH: window.innerWidth });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { auth } = nextProps;
    if (auth.user !== this.props.auth.user) {
      this.setState({ isDark: auth.user.is_night_mode, isAdmin: auth.isAdmin });
    }
  };

  openSidebar = (open) => {
    this.setState({ isOpen: open });
    localStorage.setItem("menuIsOpen", open);
  };

  logout = () => {
    this.props.actions.logoutUser();
  };

  render() {
    const { auth, codes } = this.props;
    const { isOpen, isDark, DEVICE_WIDTH } = this.state;

    // calculate width for mobile
    const isMobile = DEVICE_WIDTH < 768;
    const routeProps = {
      exact: true,
      auth,
      isMobile,
      codes,
      isMenuOpen: isOpen,
      innerWidth: window.innerWidth
    };
    return (
      <PageContainer nightmode={isDark}>
        <SessionExpiredModal />
        <div id="outer-container" style={{ height: "100%" }}>
          <main id="page-wrap" className={`container ${isOpen ? "open" : ""}`}>
            <Sidebar
              auth={auth}
              isMobile={isMobile}
              open={this.openSidebar}
              isOpen={isOpen}
            />
            <Switch>
              <PrivateRoute
                path="/app/dashboard"
                component={Dashboard}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers"
                component={CustomerPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers/add"
                component={CustomerAddPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers/:id"
                component={CustomerEditPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers/:id/calls"
                component={CustomerCallsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers/:id/itglue/:assetType"
                component={CustomerItgluePage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/customers/:id/notes"
                component={CustomerNotesPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts"
                component={ContractPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts/add"
                component={ContractAddPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts/:id"
                component={ContractEditPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts/:id/projects/:openAddProyect"
                component={ContractProjectsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts/:id/notes"
                component={ContractNotesPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/contracts/:id/prepaids"
                component={PurchaseOrderPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects"
                component={ProjectListPage}
                {...routeProps}
              />
              {/* <PrivateRoute
                path="/app/project-list"
                component={ProjectListPage}
                {...routeProps}
              /> */}
              <PrivateRoute
                path="/app/projects/add"
                component={ProjectAddPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects/:id"
                component={ProjectEditPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects/:id/calls"
                component={ProjectCallsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects/:id/tasks"
                component={ProjectTasksPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects/:id/notes"
                component={ProjectNotesPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/projects/:id/attachments"
                component={ProjectAttachmentsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/calls"
                component={CallPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/calls/add"
                component={CallAddPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/calls/:id"
                component={CallEditPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/calls/:id/parts"
                component={CallPartsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/calls/:id/notes"
                component={CallNotesPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/timesheet2"
                component={TimesheetPage2}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/timesheet"
                component={TimesheetPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/time-planner"
                component={TimePlannerPage}
                hideOnMobile
                {...routeProps}
              />
              <PrivateRoute
                path="/app/it-health-score"
                component={ITHealthScorePage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/support-tickets"
                component={SupportTicketPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/support-tickets/add/:id"
                component={ViewSupportTicket}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/support-tickets/:id"
                component={ViewSupportTicket}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/profile"
                component={AccountSettingsPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/expenses"
                component={ExpensePage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/expenses/add"
                component={ExpenseAddPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/expenses/:id"
                component={ExpenseEditPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/approval/*"
                component={ApprovalRouter}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/pto"
                component={PtoRequestListPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/pto/:id"
                component={PtoRequestPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/pto/add"
                component={PtoRequestPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports"
                component={ReportsPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/time-summary"
                component={TimeSummaryPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/contracts-by-type"
                component={ContractsByTypePage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/time-tracker"
                component={TimeTrackerPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              {/* <PrivateRoute
                path="/app/reports/customer-collection"
                component={CustomerCollectionPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              /> */}
              <PrivateRoute
                path="/app/reports/pto-balance-report"
                component={PtoBalanceReportPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/project-progress"
                component={ProjectProgressPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/customer-annuel-revenue-analytics"
                component={CustomerAnnualRevenueAnalysisPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/prepaid-deferred-revenue-balance"
                component={PrepaidDeferredRevenueBalancePage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/retainer-or-client-care-contracts"
                component={RetainerOrClientCareContractsPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/sales-performance"
                component={SalesPerformancePage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/project-summary"
                component={ProjectSummaryPage}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/billable-customer-rates"
                component={BillableCustomerRates}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/call-detail"
                component={CallDetail}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/task-detail"
                component={TaskDetail}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/customer-project-status"
                component={CustomerProjectStatus}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/project-summary-by-customer"
                component={ProjectSummaryByCustomer}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/monthly-revenue-analysis"
                component={MonthlyRevenueAnalysis}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/customer-balance-summary"
                component={CustomerBalanceSummary}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/employee-summary"
                component={EmployeeSummaryByDepartmentPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/it-managed-services"
                component={ITManagedServices}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/department-project-summary"
                component={DepartmentProjectSummary}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/employee-summary-by-project"
                component={EmployeeSummaryByProject}
                {...routeProps}
              />
              {/* <PrivateRoute
                path="/app/reports/invoice-detail"
                component={InvoiceDetail}
                {...routeProps}
              /> */}
              <PrivateRoute
                path="/app/reports/resource-summary"
                component={ResourceSummaryPage}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/daily-call-completion"
                component={DailyCallCompletion}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/open-support-tickets"
                component={OpenSupportTickets}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/project-service-analysis"
                component={ProjectServiceAnalysis}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/support-ticket-detail"
                component={SupportTicketDetailReport}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/employee-utilization"
                component={EmployeeUtilization}
                hideOnMobile
                minRole={ROLES.SALESPERSON}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/active-contracts"
                component={ActiveContracts}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/reports/active-projects"
                component={ActiveProjects}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/call"
                component={CallApprovalPage}
                hideOnMobile
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/invoice"
                component={CallApprovalPage}
                hideOnMobile
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/billing"
                component={CallApprovalPage}
                hideOnMobile
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/expenses"
                component={ExpenseApprovalPage}
                hideOnMobile
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/project"
                component={ProjectProgressReviewPage}
                hideOnMobile
                minRole={ROLES.MANAGER}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/pto"
                component={PtoApprovalPage}
                hideOnMobile
                minRole={ROLES.MANAGER}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/review/finance"
                component={CallApprovalPage}
                hideOnMobile
                minRole={ROLES.CEO}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/activity"
                component={ActivityPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/departments"
                component={DepartmentPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/users"
                component={UserPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/users/add"
                component={UserAddPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/users/:id"
                component={UserEditPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/services/add"
                component={ServiceAddPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/services/:id"
                component={ServiceEditPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/services"
                component={ServicePage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/tasks"
                component={TaskPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/roles"
                component={RolePage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/holidays"
                component={HolidayPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/codes"
                component={CodePage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/contract-tier"
                component={ContractTierPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/settings/department-categories"
                component={DepartmentCategoryPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/alt-customer-names"
                component={MaintenancePage}
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/project-keywords"
                component={ProjectKeywordsPage}
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                path="/app/support-resources"
                component={SupportResourcesPage}
                minRole={ROLES.BILLING_ADMIN}
                {...routeProps}
              />
              <PrivateRoute
                hideOnMobile
                path="/app/bulk-migration"
                component={BulkCallMigrationPage}
                minRole={ROLES.ADMIN}
                {...routeProps}
              />
              <Redirect
                from="*"
                to="/app/dashboard"
                component={Dashboard}
                {...routeProps}
              />
            </Switch>
          </main>
        </div>
      </PageContainer>
    );
  }
}

UserRoute.propTypes = {
  auth: PropTypes.object,
  callCount: PropTypes.string,
  user: PropTypes.object,
  codes: PropTypes.array,
  windowWidth: PropTypes.number,
  actions: PropTypes.object,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state,
    auth: state.reducers.auth,
    user: state.reducers.user,
    callCount: state.reducers.callCount,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions, ...codeActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserRoute);
